import {
  FilterOperationType,
  FilterType,
} from '@/components/Table/Table.constants';
import type { Filter } from '@/components/Table/Table.types';
import { ReviewStatus } from '@/containers/Review/constants/reviewConstants';

import {
  EscalatedPatientsSelection,
  reviewTypesForEscalations,
} from '../CustomPopulation.constants';

export const formatEscalatedPatientsFilter = (
  values: Nullable<EscalatedPatientsSelection>,
  _propertyName: string
): Nullable<Filter[]> => {
  if (!values) return null;

  const filters = [];

  switch (values) {
    case EscalatedPatientsSelection.UNASSIGNED:
      filters.push(
        {
          operationType: FilterOperationType.BLANK,
          propertyName: 'facilityPhysicianAdvisorId',
          type: FilterType.NUMBER,
        },
        {
          operationType: FilterOperationType.BLANK,
          propertyName: 'reviewStatus',
          type: FilterType.TEXT,
        },
        {
          operationType: FilterOperationType.IN_RANGE,
          propertyName: 'reviewTypeName',
          type: FilterType.TEXT,
          values: reviewTypesForEscalations,
        }
      );

      break;
    case EscalatedPatientsSelection.ASSIGNED_ESCALATIONS:
      filters.push(
        {
          operationType: FilterOperationType.NOT_BLANK,
          propertyName: 'facilityPhysicianAdvisorId',
          type: FilterType.NUMBER,
        },
        {
          operationType: FilterOperationType.BLANK,
          propertyName: 'reviewStatus',
          type: FilterType.TEXT,
        },
        {
          operationType: FilterOperationType.IN_RANGE,
          propertyName: 'reviewTypeName',
          type: FilterType.TEXT,
          values: reviewTypesForEscalations,
        }
      );
      break;
    case EscalatedPatientsSelection.ASSIGNED:
      filters.push(
        {
          operationType: FilterOperationType.NOT_BLANK,
          propertyName: 'facilityPhysicianAdvisorId',
          type: FilterType.NUMBER,
        },
        {
          operationType: FilterOperationType.IN_RANGE,
          propertyName: 'reviewStatus',
          type: FilterType.TEXT,
          values: [ReviewStatus.IN_PROGRESS, ReviewStatus.PENDING],
        }
      );
      break;
    case EscalatedPatientsSelection.COMPLETED:
      filters.push({
        operationType: FilterOperationType.EQUALS,
        propertyName: 'reviewStatus',
        type: FilterType.TEXT,
        value: ReviewStatus.COMPLETED,
      });
      break;
    default:
      break;
  }

  return filters.length ? (filters as Filter[]) : null;
};
